import { FC, MouseEvent, ReactNode, useEffect, useRef, useState } from 'react'
import styles from './Navbar.module.css'
import profileBtnIcon from '../../assets/icons/profileBtnIcon.svg'
import notificationIcon from '../../assets/icons/iconNotifications.svg'
import closeWhite from '../../assets/icons/closeWhite.svg'
import Logo from '../UI/Logo/Logo'
import exitIcon from '../../assets/icons/log-out.svg'
import DropDownItem from '../DropDownItem/DropDownItem'
import close from '../../assets/icons/close.svg'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import { useMediaQuery } from 'react-responsive'
import Hamburger from 'hamburger-react'
import { authLogout } from '../../redux/reducers/auth/authSlice'
import { useLocation, useNavigate } from 'react-router-dom'
import PATH from '../../navigation/path'
import DropDownProfile from '../DropDownProfile/DropDownProfile'
import { resetMeData } from '../../redux/reducers/me/meSlice'
import { getAllNotifications, readAllNotifications } from '../../redux/actions/notificationsAction'
import { format } from 'date-fns'
type NavOption = {
  id: number
  title: string
  pathMatch: string[]
}

export type NavbarPropsType = {
  isPlatforms?: boolean
  children?: ReactNode
  isWatchMode?: boolean
}

type OptionType = NavOption

const Navbar: FC<NavbarPropsType> = ({ isPlatforms, children, isWatchMode }) => {
  const [open, setOpen] = useState(false)
  const [openNotification, setOpenNotification] = useState(false)
  const [openAuth, setOpenAuth] = useState(false)
  const [activeOption, setActiveOption] = useState<number | null>(null)
  const { token } = useAppSelector((state) => state.auth)
  const { notifications } = useAppSelector((state) => state.notifications)

  const hasUnreadNotifications =
    Array.isArray(notifications) && notifications.some((notification) => !notification.isRead)

  useEffect(() => {
    if (token) {
      dispatch(getAllNotifications({ token }))
    }
  }, [token])

  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

  const userRole = useAppSelector((state) => state.auth.userRole)
  const { user } = useAppSelector((state) => state.auth)

  const roleOptionsMap: Record<string, OptionType[]> = {
    superAdmin: [
      { id: 1, title: 'Главная', pathMatch: [PATH.claimManagementPage] },
      { id: 2, title: 'Администраторы', pathMatch: [PATH.administratorsManagementPage] },
      { id: 3, title: 'Компании', pathMatch: [PATH.companyManagementPage] },
      { id: 4, title: 'Залы', pathMatch: [PATH.siteManagementPage] },
      { id: 5, title: 'Заявки', pathMatch: [PATH.claimManagementPage, PATH.claimsPage] },
      { id: 6, title: 'Запросы на регистрацию', pathMatch: [PATH.requestForRegistration] },
      { id: 7, title: 'Площадки', pathMatch: [PATH.establishmentPage] },
      { id: 8, title: 'Меню', pathMatch: [PATH.menuPage] },
      { id: 9, title: 'Отчеты', pathMatch: [PATH.statsPage] },
      { id: 10, title: 'Клиенты', pathMatch: [PATH.clientControlPage] },
      { id: 11, title: 'STR', pathMatch: [PATH.strPage, PATH.strPage] },
    ],
    admin: [
      { id: 1, title: 'Главная', pathMatch: [PATH.claimManagementPage] },
      { id: 2, title: 'Компании', pathMatch: [PATH.companyManagementPage] },
      { id: 3, title: 'Залы', pathMatch: [PATH.siteManagementPage] },
      { id: 4, title: 'Заявки', pathMatch: [PATH.claimManagementPage, PATH.claimsPage] },
      { id: 5, title: 'Запросы на регистрацию', pathMatch: [PATH.requestForRegistration] },
      { id: 6, title: 'Площадки', pathMatch: [PATH.establishmentPage] },
      { id: 7, title: 'Меню', pathMatch: [PATH.menuPage] },
      { id: 8, title: 'Отчеты', pathMatch: [PATH.statsPage] },
      { id: 9, title: 'Клиенты', pathMatch: [PATH.clientControlPage] },
      { id: 10, title: 'STR', pathMatch: [PATH.strPage, PATH.strPage] },
    ],
    directorAgent: [
      { id: 1, title: 'Главная', pathMatch: [PATH.claimManagementPage] },
      { id: 2, title: 'Отчеты', pathMatch: [PATH.statsPage] },
      { id: 3, title: 'Клиенты', pathMatch: [PATH.clientControlPage] },
      { id: 4, title: 'Меню', pathMatch: [PATH.menuPage] },
      { id: 5, title: 'Площадки', pathMatch: [PATH.establishmentPage] },
      { id: 6, title: 'Залы', pathMatch: [PATH.siteManagementPage] },
      { id: 7, title: 'Профиль', pathMatch: [PATH.profilePage] },
      { id: 8, title: 'Заявки', pathMatch: [PATH.claimManagementPage, PATH.claimsPage] },
      { id: 9, title: 'STR', pathMatch: [PATH.strPage, PATH.strPage] },
    ],
    directorPlace: [
      { id: 1, title: 'Главная', pathMatch: [PATH.claimManagementPage] },
      { id: 2, title: 'Отчеты', pathMatch: [PATH.statsPage] },
      { id: 3, title: 'Клиенты', pathMatch: [PATH.clientControlPage] },
      { id: 4, title: 'Меню', pathMatch: [PATH.menuPage] },
      { id: 5, title: 'Площадки', pathMatch: [PATH.establishmentPage] },
      { id: 6, title: 'Залы', pathMatch: [PATH.siteManagementPage] },
      { id: 7, title: 'Профиль', pathMatch: [PATH.profilePage] },
      { id: 8, title: 'Заявки', pathMatch: [PATH.claimManagementPage, PATH.claimsPage] },
      { id: 9, title: 'STR', pathMatch: [PATH.strPage, PATH.strPage] },
    ],
    employeeAgent: [
      { id: 1, title: 'Главная', pathMatch: [PATH.claimManagementPage] },
      { id: 3, title: 'Отчеты', pathMatch: [PATH.statsPage] },
      { id: 4, title: 'Клиенты', pathMatch: [PATH.clientControlPage] },
      { id: 2, title: 'Профиль', pathMatch: [PATH.profilePage] },
      { id: 5, title: 'Заявки', pathMatch: [PATH.claimManagementPage, PATH.claimsPage] },
      { id: 6, title: 'STR', pathMatch: [PATH.strPage, PATH.strPage] },
    ],
    employeePlace: [
      { id: 1, title: 'Главная', pathMatch: [PATH.claimManagementPage] },
      { id: 2, title: 'Отчеты', pathMatch: [PATH.statsPage] },
      { id: 3, title: 'Клиенты', pathMatch: [PATH.clientControlPage] },
      { id: 4, title: 'Залы', pathMatch: [PATH.siteManagementPage] },
      { id: 5, title: 'Профиль', pathMatch: [PATH.profilePage] },
      { id: 6, title: 'Заявки', pathMatch: [PATH.claimManagementPage, PATH.claimsPage] },
      { id: 7, title: 'STR', pathMatch: [PATH.strPage, PATH.strPage] },
    ],
  }

  const options = roleOptionsMap[userRole] || []

  useEffect(() => {
    const currentPath = location.pathname
    const activeOption = options.find((option) =>
      option.pathMatch.some((path) => currentPath.includes(path)),
    )

    setActiveOption(activeOption?.id || null)
  }, [location.pathname, options])

  const logoutHandler = () => {
    dispatch(resetMeData())
    dispatch(authLogout())
    navigate(PATH.mainPage)
  }

  const onOpenDropDown = (e: MouseEvent) => {
    e.stopPropagation()
    setOpen(!open)
  }
  const onOpenDropDownNotification = (e: MouseEvent) => {
    e.stopPropagation()
    setOpenNotification(!openNotification)
  }

  const onOpenDropDownAuth = (e: MouseEvent) => {
    e.stopPropagation()
    setOpenAuth(!openAuth)
  }

  const dropdownNavbarRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownNavbarRef.current && !dropdownNavbarRef.current.contains(event.target as Node)) {
        setOpen(false)
      }
    }

    // @ts-ignore
    window.addEventListener('click', handleClickOutside)

    return () => {
      // @ts-ignore
      window.removeEventListener('click', handleClickOutside)
    }
  }, [])

  return (
    <div className={styles.header}>
      <div className={styles.container}>
        <div className={styles.logoWrapper}>
          <Logo />
          {!isWatchMode && !isMobile && (
            <div className={styles.textWrapper}>
              {options?.map((option) => (
                <DropDownItem
                  key={option.id}
                  title={option.title}
                  active={activeOption === option.id}
                  setActive={setActiveOption}
                  id={option.id}
                />
              ))}
            </div>
          )}
        </div>

        {!isWatchMode && (
          <>
            {!isMobile && children}
            {isMobile ? (
              <div className={styles.containerWrapper}>
                <div
                  className={styles.profileBtn}
                  onClick={(e) => {
                    onOpenDropDownNotification(e)
                    dispatch(readAllNotifications({ token }))
                  }}
                >
                  <div className={styles.notificationIconWrapper}>
                    <img
                      className={styles.profileNotificationIcon}
                      src={notificationIcon}
                      alt='notificationIcon'
                    />
                    {hasUnreadNotifications && <div className={styles.notificationBadge}></div>}
                  </div>
                  {openNotification && (
                    <div className={styles.notificationMobileWrapper}>
                      {' '}
                      <div className={styles.notificationBlock}>
                        <div className={styles.notificationTitle}>
                          Уведомления
                          <img
                            onClick={() => setOpenNotification(false)}
                            className={styles.close}
                            src={closeWhite}
                            alt='close'
                          />
                        </div>
                        <div className={styles.notificationList}>
                          {notifications.map((notification) => {
                            if (notification.type !== 'public_place_request_created') {
                              const startDate = notification.metadata?.startDate
                                ?.slice(0, 10)
                                .slice(0, 10)
                                .split('-')
                                .reverse()
                                .join('.')
                              const startTime = notification.metadata?.startDate
                                ?.slice(11, 16)
                                .split('-')
                                .reverse()
                                .join('.')
                              const endDate = notification.metadata?.endDate
                                ?.slice(0, 10)
                                .split('-')
                                .reverse()
                                .join('.')
                              const endTime = notification.metadata?.endDate
                                ?.slice(11, 16)
                                .split('-')
                                .reverse()
                                .join('.')
                              return (
                                <div
                                  onClick={() =>
                                    navigate(
                                      `${PATH.claimCardPage}${notification.metadata?.requestId}`,
                                    )
                                  }
                                  className={styles.notificationItem}
                                  key={notification.id}
                                >
                                  <div className={styles.notificationItemTitle}>
                                    <div className={styles.notificationItemTitleText}>
                                      Заявка принята в работу{' '}
                                      {format(
                                        new Date(notification?.metadata?.createdAt || ''),
                                        'dd.MM.yyyy HH:mm',
                                      )}
                                    </div>
                                  </div>
                                  <div className={styles.notificationItemTextContainer}>
                                    {notification?.metadata && (
                                      <>
                                        <span className={styles.notificationItemText}>
                                          Ваша заявка на зал &quot;{notification.metadata.placeName}
                                          &quot; от клиента {
                                            notification.metadata.clientFullName
                                          }{' '}
                                          принята в работу
                                        </span>
                                        <span className={styles.notificationItemTextDate}>
                                          Период бронирования: {startDate} {startTime} - {endDate}{' '}
                                          {endTime}
                                        </span>
                                      </>
                                    )}
                                  </div>
                                </div>
                              )
                            } else {
                              return (
                                <div
                                  onClick={() =>
                                    navigate(
                                      `${PATH.claimCardPage}${notification.metadata?.requestId}`,
                                    )
                                  }
                                  className={styles.notificationItem}
                                  key={notification.id}
                                >
                                  <div className={styles.notificationItemTitle}>
                                    <div className={styles.notificationItemTitleText}>
                                      Заявка с внешнего сервиса
                                    </div>
                                  </div>
                                  <div className={styles.notificationItemTextContainer}>
                                    {notification?.metadata && (
                                      <>
                                        <span className={styles.notificationItemText}>
                                          Создана заявка на зал &quot;
                                          {notification.metadata.placeName}
                                          &quot; от внешнего клиента{' '}
                                          {notification.metadata.clientFullName}
                                        </span>
                                      </>
                                    )}
                                  </div>
                                </div>
                              )
                            }
                          })}

                          {notifications.length === 0 && (
                            <div className={styles.notificationItem}>
                              <div className={styles.notificationItemTitle}>
                                <div className={styles.notificationItemTitleText}>
                                  Уведомлений нет
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>{' '}
                    </div>
                  )}
                </div>
                <div className={styles.profileBtn} onClick={onOpenDropDownAuth}>
                  <img
                    className={styles.profileBtnIcon}
                    src={profileBtnIcon}
                    alt='profileBtnIcon'
                  />
                  <DropDownProfile ref={dropdownNavbarRef} open={openAuth}>
                    <div className={styles.infoBlock}>
                      <span>{user.fullName}</span>
                      <span className={styles.email}>{user.email}</span>
                    </div>
                    <div className={styles.exitBlock} onClick={logoutHandler}>
                      <img className={styles.exitIcon} src={exitIcon} alt='exit' />
                      <div className={styles.exitText}>Выход</div>
                    </div>
                  </DropDownProfile>
                </div>
                <div onClick={onOpenDropDown} className={styles.burger}>
                  <Hamburger color='white' size={28} toggled={open} toggle={() => setOpen(!open)} />
                  {open && (
                    <div className={styles.mobileMenu}>
                      <div className={styles.logoWrapperMobile}>
                        <Logo />
                        <img
                          onClick={() => setOpen(false)}
                          className={styles.close}
                          src={closeWhite}
                          alt='close'
                        />
                      </div>
                      <ul className={styles.menuContent}>
                        {options?.map((option) => (
                          <DropDownItem
                            key={option.id}
                            title={option.title}
                            active={activeOption === option.id}
                            setActive={setActiveOption}
                            id={option.id}
                          />
                        ))}
                      </ul>
                    </div>
                  )}
                  {/* <DropDown open={open}>
                    <ul className={styles.dropDownList}>
                      {options?.map((option) => (
                        <DropDownItem
                          key={option.id}
                          title={option.title}
                          active={activeOption === option.id}
                          setActive={setActiveOption}
                          id={option.id}
                        />
                      ))}
                    </ul>
                  </DropDown> */}
                </div>
              </div>
            ) : (
              <div className={styles.navbarWrapperIcons}>
                <div
                  className={styles.profileBtn}
                  onClick={(e) => {
                    onOpenDropDownNotification(e)
                    dispatch(readAllNotifications({ token }))
                  }}
                >
                  <div className={styles.notificationIconWrapper}>
                    <img
                      className={styles.profileNotificationIcon}
                      src={notificationIcon}
                      alt='notificationIcon'
                    />
                    {hasUnreadNotifications && <div className={styles.notificationBadge}></div>}
                  </div>
                  <DropDownProfile ref={dropdownNavbarRef} open={openNotification}>
                    <div className={styles.notificationBlock}>
                      <div className={styles.notificationTitle}>
                        Уведомления
                        <img
                          onClick={() => setOpenNotification(false)}
                          className={styles.close}
                          src={close}
                          alt='close'
                        />
                      </div>
                      <div className={styles.notificationList}>
                        {notifications.map((notification) => {
                          if (notification.type !== 'public_place_request_created') {
                            const startDate = notification.metadata?.startDate
                              ?.slice(0, 10)
                              .slice(0, 10)
                              .split('-')
                              .reverse()
                              .join('.')
                            const startTime = notification.metadata?.startDate
                              ?.slice(11, 16)
                              .split('-')
                              .reverse()
                              .join('.')
                            const endDate = notification.metadata?.endDate
                              ?.slice(0, 10)
                              .split('-')
                              .reverse()
                              .join('.')
                            const endTime = notification.metadata?.endDate
                              ?.slice(11, 16)
                              .split('-')
                              .reverse()
                              .join('.')
                            return (
                              <div
                                onClick={() =>
                                  navigate(
                                    `${PATH.claimCardPage}${notification.metadata?.requestId}`,
                                  )
                                }
                                className={styles.notificationItem}
                                key={notification.id}
                              >
                                <div className={styles.notificationItemTitle}>
                                  <div className={styles.notificationItemTitleText}>
                                    Заявка принята в работу{' '}
                                    {format(
                                      new Date(notification?.metadata?.createdAt || ''),
                                      'dd.MM.yyyy HH:mm',
                                    )}
                                  </div>
                                </div>
                                <div className={styles.notificationItemTextContainer}>
                                  {notification?.metadata && (
                                    <>
                                      <span className={styles.notificationItemText}>
                                        Ваша заявка на зал &quot;{notification.metadata.placeName}
                                        &quot; от клиента {
                                          notification.metadata.clientFullName
                                        }{' '}
                                        принята в работу
                                      </span>
                                      <span className={styles.notificationItemTextDate}>
                                        Период бронирования: {startDate} {startTime} - {endDate}{' '}
                                        {endTime}
                                      </span>
                                    </>
                                  )}
                                </div>
                              </div>
                            )
                          } else {
                            return (
                              <div
                                onClick={() =>
                                  navigate(
                                    `${PATH.claimCardPage}${notification.metadata?.requestId}`,
                                  )
                                }
                                className={styles.notificationItem}
                                key={notification.id}
                              >
                                <div className={styles.notificationItemTitle}>
                                  <div className={styles.notificationItemTitleText}>
                                    Заявка с внешнего сервиса
                                  </div>
                                </div>
                                <div className={styles.notificationItemTextContainer}>
                                  {notification?.metadata && (
                                    <>
                                      <span className={styles.notificationItemText}>
                                        Создана заявка на зал &quot;
                                        {notification.metadata.placeName}
                                        &quot; от клиента {notification.metadata.clientFullName}
                                      </span>
                                    </>
                                  )}
                                </div>
                              </div>
                            )
                          }
                        })}
                        {notifications.length === 0 && (
                          <div className={styles.notificationItem}>
                            <div className={styles.notificationItemTitle}>
                              <div className={styles.notificationItemTitleText}>
                                Уведомлений нет
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </DropDownProfile>
                </div>
                <div className={styles.profileBtn} onClick={onOpenDropDown}>
                  <img
                    className={styles.profileBtnIcon}
                    src={profileBtnIcon}
                    alt='profileBtnIcon'
                  />
                  <DropDownProfile ref={dropdownNavbarRef} open={open}>
                    <div className={styles.infoBlock}>
                      <span>{user.fullName}</span>
                      <span className={styles.email}>{user.email}</span>
                    </div>
                    <div className={styles.exitBlock} onClick={logoutHandler}>
                      <img className={styles.exitIcon} src={exitIcon} alt='exit' />
                      <div className={styles.exitText}>Выход</div>
                    </div>
                  </DropDownProfile>
                </div>
              </div>
            )}
          </>
        )}
      </div>
      {isMobile && isPlatforms && !isWatchMode && (
        <div className={styles.searchMobileComponent}>{children}</div>
      )}
    </div>
  )
}

export default Navbar
